module.exports = __webpack_public_path__ + "static/media/elephant.9c009032.svg";